import React, { MouseEvent, ReactElement } from 'react';
import { Button, SxProps, Theme } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

export interface IActivityActionButton {
  label: string;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  fullWidth?: boolean;
  endIcon?: ReactElement;
  sx?: SxProps<Theme>;
}

export const ActivityActionButton: React.FC<IActivityActionButton> = ({
  label,
  onClick,
  fullWidth = true,
  endIcon = <ArrowForwardIcon />,
  sx,
}): JSX.Element => {
  return (
    <Button
      variant="contained"
      color="primary"
      fullWidth={fullWidth}
      endIcon={endIcon}
      onClick={onClick}
      sx={{
        mt: 1.5,
        ...sx,
      }}
    >
      {label}
    </Button>
  );
};
